module.exports = __webpack_public_path__ + "ddd91d10c44d12ad1ed069cbb9879acc.pdf";